import React, { Fragment } from 'react';
import { StagedModal, StagedModalStages } from 'react-viiad-core-ui/src/Components/Core/StagedModal';
import { Tabs, Tab } from 'react-viiad-core-ui/src/Components/Core/Tabs';
import { Input } from 'react-viiad-core-ui/src/Components/Core/Forms';
import axios from 'axios';
import { IsMaskedInputValidated } from 'react-viiad-core-ui/src/Utilities/forms';

export const SHARE_TYPES = {
    EMAIL: "email",
    FAX: "fax",
    PRINT: "print",
    TEXT: "text",
    DOWNLOAD: "download"
};

const SEND_BTN_TEXT = {
    [SHARE_TYPES.EMAIL]: "Send",
    [SHARE_TYPES.FAX]: "Send",
    [SHARE_TYPES.PRINT]: "Print",
    [SHARE_TYPES.DOWNLOAD]: "Download",
    [SHARE_TYPES.TEXT]: "Send",
    "": "Send",
};

const SEND_BTN_TEXT_PASTTENSE = {
    [SHARE_TYPES.EMAIL]: "Sent",
    [SHARE_TYPES.FAX]: "Sent",
    [SHARE_TYPES.PRINT]: "Printed",
    [SHARE_TYPES.DOWNLOAD]: "Downloaded",
    [SHARE_TYPES.TEXT]: "Sent",
    "": "Sent",
}
/**
 * PharmacyCardSharerApp
 */
export class PharmacyCardSharerApp extends React.Component {


    static defaultProps = {
        title: "Share",
        endpoints: {
            download: '',
            email: '',
            print: ''
        },
        document: {},
        selectedTab: null,
        environment: null,
        onClose: () => { }
    };

    constructor(props) {
        super(props);
        let initSelectedTab = this.props.selectedTab || Object.keys(this.props.endpoints)[0];
        this.state = {
            validated: false,
            selectedTab: initSelectedTab,
            stage: StagedModalStages.EDIT,
            SendTo: "",
            sendBtnText: SEND_BTN_TEXT[initSelectedTab]
        };
    }

    componentDidMount() {
        this.validate();
    }

    render() {
        return (<StagedModal
            onClose={this.props.onClose}
            isOpen
            environment={this.props.environment}
            title={this.props.title}
            successStageTitle={this.props.title}
            errorStageTitle={this.props.title}
            affirmationBtnText={this.state.sendBtnText}
            renderEditStage={() => (
                <div>
                    <div className="h5 text-center">Please make a selection...</div>
                    <Tabs
                        activeTabKey={this.state.selectedTab}
                        onTabClick={(tabKey) => {
                            this.setState({ selectedTab: tabKey, sendBtnText: SEND_BTN_TEXT[tabKey], SendTo: "" }, () => {
                                this.validate();
                            });
                        }}>

                        {(SHARE_TYPES.DOWNLOAD in this.props.endpoints) &&
                            <Tab tabKey={SHARE_TYPES.DOWNLOAD} renderContent={(props) => {
                                return (
                                    <div className="my-8 text-center h4">
                                        You're all set! Please click the button below.
                                    </div>
                                )
                            }}>
                                <i className="fa fa-print fa-lg mr-3"></i>Download
                            </Tab>
                        }

                        {(SHARE_TYPES.EMAIL in this.props.endpoints) &&
                            <Tab tabKey={SHARE_TYPES.EMAIL} renderContent={(props) => {
                                return (
                                    <div className="my-8 text-center">
                                        <Input
                                            className="form-control w-33rem mx-auto"
                                            label="Enter Email Address"
                                            placeholder="Enter Email Address"
                                            name="SendTo"
                                            onChange={this.updateInput}
                                            value={this.state.SendTo}
                                        />
                                    </div>
                                )
                            }}>
                                <i className="fa fa-envelope fa-lg mr-3"></i>E-Mail
                            </Tab>
                        }

                        {(SHARE_TYPES.TEXT in this.props.endpoints) &&
                            <Tab tabKey={SHARE_TYPES.TEXT} renderContent={(props) => {
                                return (
                                    <div className="my-8 text-center">
                                        <Input
                                            className="form-control w-33rem mx-auto"
                                            label="Enter Phone Number"
                                            placeholder="Enter Phone Number"
                                            name="SendTo"
                                            onChange={this.updateInput}
                                            value={this.state.SendTo}
                                            mask={['(', ...new Array(3).fill(/\d/), ')', ...new Array(3).fill(/\d/), '-', ...new Array(4).fill(/\d/)]}
                                        />
                                    </div>
                                )
                            }}>
                                <i className="fa fa-phone fa-lg mr-3"></i>Text
                            </Tab>
                        }

                        {(SHARE_TYPES.PRINT in this.props.endpoints) &&
                            <Tab tabKey={SHARE_TYPES.PRINT} renderContent={(props) => {
                                return (
                                    <div className="my-8 text-center h4">
                                        You're all set! Please click the button below.
                                    </div>
                                )
                            }}>
                                <i className="fa fa-print fa-lg mr-3"></i>Print
                            </Tab>
                        }
                    </Tabs>
                </div>
            )}
            affirmationBtnClass={this.state.validated ? "" : "disabled"}

            onAffirmation={this.send[this.state.selectedTab]}

            renderSavingText={"Sending your document..."}

            renderSuccessStage={() => {
                return (
                    <div className="text-center py-6">
                        <div className="fa fa-check-circle fa-4x text-success"></div>
                        <div className="h4 pt-6">Your document has been {(SEND_BTN_TEXT_PASTTENSE[this.state.selectedTab] || "sent").toLowerCase()}!</div>
                    </div>
                );
            }}
        />
        )
    }


    /*
     * updateInput
     */
    updateInput = (m, n, v) => {
        this.setState({ [n]: v }, () => {
            //apply on every change
            this.validate();
        });
    }

    /*
     * updateInput
     */
    validate() {
        if (this.state.selectedTab == SHARE_TYPES.EMAIL &&
            !util.isValidEmail(this.state.SendTo)) {
            this.setState({ validated: false });
            return false;
        }
        else if ((this.state.selectedTab == SHARE_TYPES.TEXT) &&
            !IsMaskedInputValidated(this.state.SendTo)) {
            this.setState({ validated: false });
            return false;
        }
        this.setState({ validated: true });
    }

    /*
     * send - functions map
     */
    send = {

        [SHARE_TYPES.EMAIL]: (resolve, reject) => {
            this.sendPostRequest(this.props.endpoints.email, SHARE_TYPES.EMAIL, { SendTo: this.state.SendTo }, resolve, reject);
        },
        [SHARE_TYPES.DOWNLOAD]: (resolve, reject) => {
        },
        [SHARE_TYPES.PRINT]: (resolve, reject) => {
            window.open(this.props.document.URL, '_blank');
            setTimeout(resolve, 1500);
        },
        [SHARE_TYPES.TEXT]: (resolve, reject) => {
            this.sendPostRequest(this.props.endpoints.text, SHARE_TYPES.TEXT, { SendTo: this.state.SendTo }, resolve, reject);
        }
    };

    /*
     * sendPostRequest
     */
    sendPostRequest(url, type, parameters, resolve, reject) {

        axios.post(url, Object.assign({}, parameters, { type: type, document: this.props.document })).then((response) => {
            let responseData = response.data;
            if (responseData.Code !== 0) {
                console.error(responseData);
                reject();
            } else {
                resolve();
            }
        }).catch((err) => {
            console.error(responseData);
            reject();
        });

    }


}